module.exports = __webpack_public_path__ + "bed5b2ab464808e6d6ee9bb2f49db726.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/blue.png
// module id = 3353
// module chunks = 0